import { render, staticRenderFns } from "./ReportingNumber.vue?vue&type=template&id=169dba47&scoped=true&"
import script from "./ReportingNumber.vue?vue&type=script&lang=js&"
export * from "./ReportingNumber.vue?vue&type=script&lang=js&"
import style0 from "./ReportingNumber.vue?vue&type=style&index=0&id=169dba47&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "169dba47",
  null
  
)

export default component.exports